import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profile from "../../assets/images/profile.jpg";
import { connect, useDispatch } from "react-redux";
import { logout } from "../../redux/action/auth";
import { APIURL } from "../../redux/action/config";
import axios from "axios";

const Sidebar = (props) => {
  const dispatch = useDispatch();
  const id = localStorage.getItem("userId");
  const [profileDetails, setProfileDetails] = useState();

  useEffect(() => {
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(`${APIURL}/api/v1/users/${id}`, config)
      .then((response) => {
        setProfileDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const profiles = profileDetails?.data?.user ? profileDetails?.data?.user : "";

  return (
    <React.Fragment>
      <div className="aside-menu flex-column-fluid">
        <div
          className="hover-scroll-overlay-y px-2 my-5 my-lg-5 "
          id="kt_aside_menu_wrapper"
          data-kt-scroll="true"
          data-kt-scroll-height="auto"
          data-kt-scroll-dependencies="{default: '#kt_aside_toolbar, #kt_aside_footer', lg: '#kt_header, #kt_aside_toolbar, #kt_aside_footer'}"
          data-kt-scroll-offset="0"
        >
          <div
            className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold"
            id="#kt_aside_menu"
            data-kt-menu="true"
          >
            <div className="menu-outer">
              <div
                className={`menu-item ${
                  props.page === "dashboard" ? "here" : ""
                }`}
              >
                <Link className="menu-link" to="/dashboard">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Dashboard</span>
                </Link>
              </div>
            </div>
            <div className="menu-outer">
              <div
                className={`menu-item ${
                  props.page === "orders" ||
                  props.page === "editOrders" ||
                  props.page === "viewServiceRequest"
                    ? "here"
                    : ""
                }`}
              >
                <Link className="menu-link" to="/orders">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Order Manager</span>
                </Link>
              </div>
            </div>
            <div className="menu-outer">
              <div
                className={`menu-item ${
                  props.page === "affiliate" ? "here" : ""
                }`}
              >
                <Link className="menu-link" to="/manage-affiliates">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Affiliate Applications</span>
                </Link>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-fleet"
                aria-expanded="true"
                aria-controls="collapse-fleet"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Fleet</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "fleet" ? "show" : ""}
              ${props.page === "addfleet" ? "show" : ""}
              ${props.page === "editFleet" ? "show" : ""}
              `}
                id="collapse-fleet"
              >
                <div
                  className={`menu-item ${
                    props.page === "fleet" || props.page === "editFleet"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-fleet">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage Fleet</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addfleet" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-fleet">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Fleet </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-staff"
                aria-expanded="true"
                aria-controls="collapse-staff"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Staff</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "staff" ? "show" : ""}
                ${props.page === "addstaff" ? "show" : ""}
                ${props.page === "editStaff" ? "show" : ""}
                `}
                id="collapse-staff"
              >
                <div
                  className={`menu-item ${
                    props.page === "staff" || props.page === "editStaff"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-staff">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage Staff</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addstaff" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-staff">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Staff </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-checklists"
                aria-expanded="true"
                aria-controls="collapse-checklists"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">CheckLists</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${
                  props.page === "checklists" ? "show" : ""
                }
                ${props.page === "addchecklists" ? "show" : ""}
                ${props.page === "add-category" ? "show" : ""}
                ${props.page === "editchecklists" ? "show" : ""}
                ${props.page === "edit-category" ? "show" : ""}
                `}
                id="collapse-checklists"
              >
                <div
                  className={`menu-item ${
                    props.page === "checklists" ||
                    props.page === "editchecklists"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-checklists">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage CheckLists</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addchecklists" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-checklists">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Item</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "add-category" ||
                    props.page === "edit-category"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-category">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Category </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-customers"
                aria-expanded="true"
                aria-controls="collapse-customers"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Customers</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "customers" ? "show" : ""}
                ${props.page === "addcustomers" ? "show" : ""}
                ${props.page === "editCustomer" ? "show" : ""}
                `}
                id="collapse-customers"
              >
                <div
                  className={`menu-item ${
                    props.page === "customers" || props.page === "editCustomer"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-customers">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage Customers</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addcustomers" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-customer">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Customers </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-services"
                aria-expanded="true"
                aria-controls="collapse-services"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Manage Services</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "services" ? "show" : ""}
                ${props.page === "addService" ? "show" : ""}
                ${props.page === "editServices" ? "show" : ""}
                `}
                id="collapse-services"
              >
                <div
                  className={`menu-item ${
                    props.page === "services" || props.page === "editServices"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-service">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage Services</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addService" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-service">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Services </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-memberships"
                aria-expanded="true"
                aria-controls="collapse-memberships"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Manage Memberships</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${
                  props.page === "memberships" ? "show" : ""
                }
                ${props.page === "addMembership" ? "show" : ""}
                ${props.page === "editMembership" ? "show" : ""}`}
                id="collapse-memberships"
              >
                <div
                  className={`menu-item ${
                    props.page === "memberships" ||
                    props.page === "editMembership"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-membership">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage Memberships</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addMembership" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-membership">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Memberships </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-vehicle"
                aria-expanded="true"
                aria-controls="collapse-vehicle"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Rentals</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "vehicles" ? "show" : ""}
                ${props.page === "addVehicle" ? "show" : ""} 
                ${props.page === "rental-vehicle-orders" ? "show" : ""}
                ${props.page === "editvehicle" ? "show" : ""}
                ${props.page === "viewOrderDetail" ? "show" : ""}
                ${props.page === "rentalAddon" ? "show" : ""}
                ${props.page === "edit-addon" ? "show" : ""}
                `}
                id="collapse-vehicle"
              >
                <div
                  className={`menu-item ${
                    props.page === "rental-vehicle-orders" ||
                    props.page === "viewOrderDetail"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/rental-vehicle-orders">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Rental Orders</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "vehicles" || props.page === `editvehicle`
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/all-rentals">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage All Rentals</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addVehicle" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-rental">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Rental</span>
                  </Link>
                </div>
                <div
                  // className={`menu-item ${
                  //   props.page === "rentalAddon" ? "selected" : ""
                  // }`}
                  className={`menu-item ${
                    props.page === "rentalAddon" || props.page === "edit-addon"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/mange-rental-add-on">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Rental Add-ons</span>
                  </Link>
                </div>
              </div>
              <div
                className={`menu-item ${
                  props.page === "checklists" || props.page === "discount"
                    ? "here"
                    : ""
                }`}
              >
                <Link className="menu-link" to="/discount">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Discount</span>
                  <span className="menu-arrow"></span>
                </Link>
              </div>
              <div
                className={`menu-item ${
                  props.page === "checklists" || props.page === "charges"
                    ? "here"
                    : ""
                }`}
              >
                <Link className="menu-link" to="/add-transition-charges">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Additional Prices</span>
                  <span className="menu-arrow"></span>
                </Link>
              </div>
              {/* <div
                className={`menu-item ${props.page === "invoice" ||
                    props.page === "invoice"
                    ? "here"
                    : ""
                  }`}
              >
                <Link className="menu-link" to="/invoice">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Invoice</span>
                  <span className="menu-arrow"></span>
                </Link>
              </div> */}
            </div>
            <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-invoice"
                aria-expanded="true"
                aria-controls="collapse-invoice"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">On Demand</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "invoice" ? "show" : ""}
              ${props.page === "invoicelist" ? "show" : ""}
              `}
                id="collapse-invoice"
              >
                <div
                  className={`menu-item ${
                    props.page === "invoice" || props.page === "editinvoice"
                      ? "selected"
                      : ""
                  }`}
                >
                  <Link className="menu-link" to="/invoice">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Create New</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "invoicelist" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/invoice-list">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">List of Invoices </span>
                  </Link>
                </div>
              </div>
            </div>
            {/* <div className="menu-outer">
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-others"
                aria-expanded="true"
                aria-controls="collapse-others"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Additional Prices</span>
                  <span className="menu-arrow"></span>
                </span>
              </div>
              <div
                className={`collapse ${props.page === "charges" ? "show" : ""}
              ${props.page === "surge" ? "show" : ""}
              `}
                id="collapse-others"
              >
                <div
                  className={`menu-item ${props.page === "charges"
                      ? "selected"
                      : ""
                    }`}
                >
                  <Link className="menu-link" to="/add-transition-charges">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Transaction Charges</span>
                  </Link>
                </div>
              </div>
            </div> */}
            {/* <div className="menu-outer"> */}
            {/* <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion"
                data-bs-toggle="collapse"
                href="#collapse-rent-vehicle"
                aria-expanded="true"
                aria-controls="collapse-rent-vehicle"
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Manage Rented Item</span>
                  <span className="menu-arrow"></span>
                </span>
              </div> */}
            {/* <div
                className={`collapse ${
                  props.page === "rent-vehicles" ? "show" : ""
                }
                // ${props.page === "booked-rent-vehicle" ? "show" : ""}`}
                id="collapse-rent-vehicle"
              > */}
            {/* <div
                  className={`menu-item ${
                    props.page === "booked-rent-vehicle" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/booked-rent-vehicle">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Booked Rented</span>
                  </Link>
                </div> */}
            {/* <div
                  className={`menu-item ${
                    props.page === "rent-vehicles" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-rent-vehicles">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">All Rented</span>
                  </Link>
                </div>
              </div> */}
          </div>
          {/* <div
              data-kt-menu-trigger="click"
              className="menu-item menu-accordion"
              data-bs-toggle="collapse"
              href="#collapse-vehicle"
              aria-expanded="true"
              aria-controls="collapse-memberships"
            >
              <span className="menu-link">
                <span className="menu-icon">
                  <span className="svg-icon svg-icon-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                        fill="black"
                      />
                      <path
                        opacity="0.3"
                        d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </span>
                <span className="menu-title">Manage Memberships</span>
                <span className="menu-arrow"></span>
              </span>
              <div
                className={`collapse ${
                  props.page === "memberships" ? "show" : ""
                }
                ${props.page === "addMembership" ? "show" : ""}`}
                id="collapse-memberships"
              >
                <div
                  className={`menu-item ${
                    props.page === "memberships" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/manage-membership">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Manage Memberships</span>
                  </Link>
                </div>
                <div
                  className={`menu-item ${
                    props.page === "addMembership" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-membership">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add New Memberships </span>
                  </Link>
                </div>
              </div>
            </div> */}
          {/* <div
              data-kt-menu-trigger="click"
              className="menu-item menu-accordion"
              data-bs-toggle="collapse"
              href="#collapse-stripe"
              aria-expanded="true"
              aria-controls="collapse-stripe"
            >
              <span className="menu-link">
                <span className="menu-icon">
                  <span className="svg-icon svg-icon-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z"
                        fill="black"
                      />
                      <path
                        opacity="0.3"
                        d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </span>
                <span className="menu-title">Manage stripe</span>
                <span className="menu-arrow"></span>
              </span>
              <div
                className={`collapse ${props.page === "stripe" ? "show" : ""}
                ${props.page === "addStripe" ? "show" : ""}`}
                id="collapse-stripe"
              >
                <div
                  className={`menu-item ${
                    props.page === "addStripe" ? "selected" : ""
                  }`}
                >
                  <Link className="menu-link" to="/add-stripe">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot"></span>
                    </span>
                    <span className="menu-title">Add Stripe Key </span>
                  </Link>
                </div>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>
      <div className="aside-footer flex-column-auto pb-5" id="kt_aside_footer">
        <div className="aside-user">
          <div className="aside-user d-flex align-items-sm-center justify-content-center py-5">
            <div className="me-5">
              <div
                className="symbol symbol-40px cursor-pointer"
                data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                data-kt-menu-placement="bottom-start"
                data-kt-menu-overflow="true"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={
                    profiles?.image ? APIURL + "/" + profiles?.image : profile
                  }
                  alt="profile"
                />
              </div>
              <div
                className="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
                data-kt-menu="true"
              >
                <div className="menu-item px-3">
                  <div className="menu-content d-flex align-items-center px-3">
                    <div className="symbol symbol-50px me-5">
                      <img
                        alt="Logo"
                        src={
                          profiles?.image
                            ? APIURL + "/" + profiles?.image
                            : profile
                        }
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fw-bolder d-flex align-items-center fs-5">
                        {profiles?.firstName ? profiles?.firstName : "User"}
                        <span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">
                          Founder
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="separator my-2"></div>
                <div className="menu-item px-5 my-1">
                  <Link to={`/profile/${id}`} className="menu-link px-5">
                    Profile settings
                  </Link>
                </div>
                <div className="menu-item px-5">
                  <Link
                    to="#"
                    onClick={() => dispatch(logout())}
                    className="menu-link px-5"
                  >
                    Sign Out
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex-row-fluid flex-wrap">
              <div className="d-flex align-items-center flex-stack">
                <div className="me-2">
                  <Link
                    to="#"
                    className="text-gray-800 text-hover-primary fs-6 fw-bold lh-0"
                  >
                    {profiles?.firstName ? profiles?.firstName : "User"}
                  </Link>
                  <span className="text-gray-400 fw-bold d-block fs-8">
                    Founder
                  </span>
                </div>
                <Link
                  to="#"
                  onClick={() => dispatch(logout())}
                  className="btn btn-icon btn-active-color-primary me-n4"
                  data-bs-toggle="tooltip"
                  title="End session and singout"
                >
                  <span className="svg-icon svg-icon-2 svg-icon-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect
                        opacity="0.3"
                        width="12"
                        height="2"
                        rx="1"
                        transform="matrix(-1 0 0 1 15.5 11)"
                        fill="black"
                      />
                      <path
                        d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z"
                        fill="black"
                      />
                      <path
                        d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z"
                        fill="#C4C4C4"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default connect(null, { logout })(Sidebar);
